import {v4} from 'uuid'

export function uuidv4(): string {
    return v4()
}
